<div class="login-container">
    <div class="login-backdrop" aria-hidden="true">
        <div class="login-backdrop__blob login-backdrop__blob--1"></div>
        <div class="login-backdrop__blob login-backdrop__blob--2"></div>
        <div class="login-backdrop__blob login-backdrop__blob--3"></div>
        <div class="login-backdrop__mesh"></div>
    </div>

    <header class="auth-header">
        <div class="brand">
            <div class="logo-container">
                <svg
                    class="logo-svg"
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="36"
                    viewBox="0 0 21 36"
                    fill="none"
                    aria-hidden="true"
                >
                    <path
                        d="M6.23211 6.48061L0 0V7.85072C0 9.10241 0.484437 10.3061 1.35251 11.2075L6.23309 16.2808V6.48061H6.23211Z"
                        fill="#D6AA54"
                    ></path>
                    <path
                        d="M6.23535 16.339L12.4684 9.85938V17.7101C12.4684 18.9618 11.984 20.1655 11.1159 21.0669L6.23535 26.1402V16.339Z"
                        fill="#D6AA54"
                    ></path>
                    <path
                        d="M6.23309 26.1984L0 19.7188V27.5695C0 28.8212 0.484437 30.0249 1.35251 30.9262L6.23309 35.9995V26.1984Z"
                        fill="#D6AA54"
                    ></path>
                    <path d="M20.1742 0H19.5498V35.9996H20.1742V0Z" fill="black"></path>
                </svg>
                <div class="logo-text-block">
                    <span class="logo-text">Doktar</span>
                    <span class="logo-sub">Backoffice</span>
                </div>
            </div>
        </div>
    </header>

    <main class="login-main">
        <form class="login-form login-card" [formGroup]="loginForm">
            <div class="header">
                <h1 class="title-text">Login</h1>
                <p class="subtitle-text">Welcome back! Enter your registered phone number or email to get started.</p>
            </div>

            <div class="form-field">
                <label class="field-label" for="email">
                    <i class="ph ph-envelope field-label__icon" aria-hidden="true"></i>
                    Email
                </label>
                <input
                    id="email"
                    pinputtext
                    type="email"
                    name="email"
                    class="p-inputtext p-component input-text"
                    placeholder="Enter your email"
                    formControlName="email"
                    [ngClass]="{
                        'is-invalid': loginForm.get('email')?.invalid && loginForm.get('email')?.touched,
                    }"
                />

                @if (loginForm.get('email')?.invalid && loginForm.get('email')?.touched) {
                    <div class="invalid-feedback">
                        @if (loginForm.get('email')?.errors?.['required']) {
                            <span>*Email is required</span>
                        }
                        @if (loginForm.get('email')?.errors?.['email']) {
                            <span>*Please enter a valid email address</span>
                        }
                    </div>
                }
            </div>

            <div class="form-field">
                <label class="field-label" for="password">
                    <i class="ph ph-lock field-label__icon" aria-hidden="true"></i>
                    Password
                </label>
                <p-password
                    id="password"
                    inputstyleclass="input-text"
                    name="password"
                    feedback="false"
                    class="password-input-container"
                    placeholder="Enter your password"
                    [toggleMask]="true"
                    formControlName="password"
                    [ngClass]="{
                        'is-invalid': loginForm.get('password')?.invalid && loginForm.get('password')?.touched,
                    }"
                >
                    <ng-template pTemplate="showicon">
                        <span
                            class="p-component p-iconwrapper p-password-toggle-mask-icon p-password-mask-icon mask-icon"
                            >{{ 'Show' }}</span
                        >
                    </ng-template>
                    <ng-template pTemplate="hideicon">
                        <span
                            class="p-component p-iconwrapper p-password-toggle-mask-icon p-password-mask-icon mask-icon"
                            >{{ 'Hide' }}</span
                        >
                    </ng-template>
                </p-password>

                @if (loginForm.get('password')?.invalid && loginForm.get('password')?.touched) {
                    <div class="invalid-feedback">*{{ getPasswordErrorMessage() }}</div>
                }
            </div>

            <div class="login-actions">
                <button pbutton class="login-button p-button p-component" (click)="login()" [disabled]="!loginForm.valid">
                    <span variant="text" class="p-button-label">Login</span>
                    <i class="ph ph-arrow-right login-button__arrow" aria-hidden="true"></i>
                </button>
            </div>

            <div class="reset-section">
                <p class="reset-description">
                    You log in here with your Doktar Account. If you reset your password, make sure to choose one that’s at
                    least 16 characters long and strong enough so you can access the Backoffice securely.
                </p>
                <a class="reset-link" [href]="forgetPasswordLink" target="_blank" rel="noopener noreferrer">
                    <span class="reset-link-text">Reset Password</span>
                    <span class="reset-link-icon" aria-hidden="true">→</span>
                </a>
            </div>
        </form>
    </main>
</div>
<p-toast />
<div class="overlay" *ngIf="loadingService.loading$ | async">
    <p-progressSpinner styleClass="spinner"></p-progressSpinner>
</div>
